export const systemAssistantState = {
    name: 'app.system.assistant',
    url: '/assistant',
    component: 'system'
};
